import styled from 'styled-components';
import { Form, Typography } from 'antd';

const { Paragraph } = Typography;

export const FormTicket = styled(Form)`
  .ant-form-item-explain-error {
    color: #e55015;
    font-style: italic;
  }
  .error-styled {
    .ant-form-item-explain-error {
      margin-left: -120px;
      margin-top: 5px;
      display: flex;
      justify-content: flex-end;
    }
  }
`;

export const Image = styled.img`
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const Discount = styled.div`
  position: absolute;
  background-color: #e92127;
  top: 0;
  height: 32px;
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 18px;
  &:before {
    content: '';
    position: absolute;
    right: -16px;
    bottom: 0px;
    width: 0;
    height: 0;
    border-left: 16px solid #e92127;
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
  }
`;

export const Title = styled(Paragraph)`
  margin: 0;
  color: #000000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px !important;
`;

export const Description = styled(Paragraph)`
  margin: 0;
  color: #808080;
  font-size: 14px;
  margin-bottom: 8px !important;
`;

export const StyledInputNumber = styled.div`
  border: 1px solid #e7e7e7;
  border-radius: 6px;
  height: 35px;
  width: 100px;
  display: flex;
  align-items: center;
  padding: 2px;
  .ant-input-number-group-addon {
    border: none;
    background: transparent;
    cursor: pointer;
    width: 22px;
    padding: 0;
  }
  .ant-input-number {
    border: none;
    input {
      text-align: center;
      font-weight: 700;
      padding: 0;
    }
  }
`;
